import React, { useEffect,useState } from "react";
import { Sparkle} from "lucide-react";

import aiInOralDiagnostics from "../assets/tracks/AI_in_Oral_ Diagnostics.jpg";
import publicHealth from "../assets/tracks/Public_Health.jpg";
import pharmacology from "../assets/tracks/Pharmacology.jpg";
import oralCancer from "../assets/tracks/Oral_Cancer.jpg";
import euroDentistry from "../assets/tracks/Euro_Dentistry.jpg";
import forensicDentistry from "../assets/tracks/Forensic_Dentistry.jpg";
import threeDImaging from "../assets/tracks/3d_imaging.jpg";
import covid19OnDentalCare from "../assets/tracks/COVID_19_on_ Dental_Care.jpg";
import dentalInstruments from "../assets/tracks/Dental_Instruments.jpg";
import periodontics from "../assets/tracks/Periodontics.jpg";
import oralPathophysiology from "../assets/tracks/Oral_Pathophysiology.jpg";
import emergingTechnologies from "../assets/tracks/Emerging Technologies.jpg";
import painManagement from "../assets/tracks/Pain_Management.jpg";
import oralOncology from "../assets/tracks/Oral_Oncology.jpg";
import digitalDentalEducation from "../assets/tracks/Digital_Dental_Education.jpg";
import nutritionalDeficiencies from "../assets/tracks/Nutritional_Deficiencies.jpg";
import forensicOralMedicine from "../assets/tracks/Forensic_Oral_Medicine.jpg";
import cosmeticDentistry from "../assets/tracks/Cosmetic_Dentistry.jpg";
import gerontology from "../assets/tracks/Gerontology.jpg";
import dentalStemCells from "../assets/tracks/Dental_Stem_Cells.jpg";
import oralImplantology from "../assets/tracks/Oral_Implantology_image.jpg";
import dentalPharmacology from "../assets/tracks/Dental_Pharmacology_image.jpg";
import orthodontics from "../assets/tracks/Orthodontics_images.jpg";
import maxillofacialSurgery from "../assets/tracks/maxillofacial_surgery_image.jpg";
import sleepDentistry from "../assets/tracks/Sleep_Dentistry_image.jpg";
import geriatricDentistry from "../assets/tracks/Geriatric_Dentistry_image.jpg";
import pediatricDentistry from "../assets/tracks/Pediatric_Dentistry_images.jpg";
import endodontics from "../assets/tracks/endodontics_images.jpg";
import laserDentistry from "../assets/tracks/Laser_Dentistry_image.jpg";

export const tracks = [
  {
    image: aiInOralDiagnostics,
    title: "AI in Oral Diagnostics",
    subtitle: "Revolutionizing Diagnosis with AI",
    description:
      "Artificial intelligence is transforming oral diagnostics by enabling earlier detection, minimizing error, and improving precision. AI tools enhance accessibility, support predictive insights, and streamline care delivery across populations. This session explores the latest trends, current tools, and future potential of digital diagnostics in reshaping the landscape of modern dental practice.",
  },
  {
    image: oralImplantology,
    title: "Oral Implantology",
    subtitle: "Implants that Restore and Rebuild",
    description:
      "Oral Implantology focuses on placing and restoring dental implants—artificial roots that support crowns, bridges, or dentures. It integrates prosthodontics, periodontics, and surgery to restore aesthetics and function. Discover clinical techniques, case planning, materials, and outcomes that are redefining the standards in treating tooth loss and oral rehabilitation today.",
  },
  {
    image: dentalPharmacology,
    title: "Dental Pharmacology",
    subtitle: "Dental Pharmacology Insights",
    description:
      "Dental pharmacology involves the study of medications used to prevent, diagnose, and treat oral diseases. Understand how drugs interact with dental procedures, manage pain, control infections, and enhance recovery. Gain insight into antibiotic stewardship, analgesics, anesthesia, and how pharmacological knowledge supports patient safety and treatment success in dentistry.",
  },
  {
    image: oralCancer,
    title: "Oral Cancer",
    subtitle: "Oral Cancer: Detection & Care",
    description:
      "Explore the clinical presentation, diagnostic protocols, risk factors, and treatment strategies of oral cancer. Learn about early warning signs, biopsy techniques, and the importance of timely intervention. Discover advances in therapy, patient education, and multidisciplinary care that are improving survival rates and transforming outcomes for patients with oral malignancies.",
  },
  {
    image: orthodontics,
    title: "Orthodontics",
    subtitle: "Straightening Smiles, Strengthening Function",
    description:
      "Orthodontics focuses on correcting misaligned teeth and jaws to improve oral function, aesthetics, and health. Learn about diagnostic tools, treatment planning, appliances, and digital innovations. Discover how early intervention and customized therapies are enhancing patient outcomes while advancing functional, structural, and cosmetic goals in contemporary orthodontic care.",
  },
  {
    image: forensicDentistry,
    title: "Forensic Dentistry",
    subtitle: "Forensic Dentistry in Investigations",
    description:
      "Forensic dentistry uses dental science in legal settings for identification, age estimation, and bite mark analysis. Explore its role in disaster victim identification, abuse investigations, and historical remains. Learn techniques, protocols, and real-life applications in cases where dental evidence plays a vital role in supporting justice and closure.",
  },
  {
    image: threeDImaging,
    title: "3D Imaging",
    subtitle: "3D Imaging: The New Dental Lens",
    description:
      "3D imaging is revolutionizing dental diagnostics and planning with detailed visualizations of anatomy. From CBCT scans to intraoral impressions, discover how these technologies enhance precision, aid surgical procedures, and improve communication. Learn how 3D tools are transforming patient outcomes and elevating standards in clinical decision-making across specialties.",
  },
  {
    image: maxillofacialSurgery,
    title: "Maxillofacial Surgery",
    subtitle: "Surgical Solutions for Complex Facial Needs",
    description:
      "Maxillofacial surgery addresses diseases, injuries, and defects of the face, mouth, and jaw. It merges dentistry and surgical expertise to treat trauma, congenital issues, pathology, and cosmetic concerns. Explore operative procedures, diagnostic imaging, reconstructive techniques, and anesthesia protocols that restore both functionality and aesthetics in comprehensive facial care.",
  },
  {
    image: sleepDentistry,
    title: "Sleep Dentistry",
    subtitle: "Sleep Dentistry: Breathing Easier, Sleeping Better",
    description:
      "Sleep dentistry focuses on treating sleep-related breathing disorders such as obstructive sleep apnea (OSA) and chronic snoring. Learn about oral appliance therapy, airway assessment, and dental contributions to interdisciplinary care. Discover how sleep disorders impact systemic health and how dentists play a critical role in treatment and prevention.",
  },
  {
    image: periodontics,
    title: "Periodontics",
    subtitle: "Periodontics: Beyond the Gumline",
    description:
      "Periodontics examines the health of tooth-supporting structures like gums and bone. Learn about causes, prevention, and treatment of periodontal disease. Explore surgical and regenerative therapies, laser use, and systemic links. Understand how periodontal health is essential to both oral function and overall wellness in long-term patient care.",
  },
  {
    image: oralPathophysiology,
    title: "Oral Pathophysiology",
    subtitle: "Understanding Oral Disease Mechanisms",
    description:
      "Oral pathophysiology explores cellular and molecular mechanisms underlying oral diseases, including inflammation, neoplasms, and infections. Gain insight into how tissues respond to trauma, autoimmune disorders, and environmental stress. Discover how accurate pathophysiological knowledge enhances diagnosis, prognosis, and targeted treatment of complex lesions in dental clinical practice.",
  },
  {
    image: geriatricDentistry,
    title: "Geriatric Dentistry",
    subtitle: "Geriatric Dentistry & Aging Care",
    description:
      "Geriatric dentistry addresses oral challenges in older adults, including dry mouth, root caries, and prosthetic needs. Explore care planning, systemic links, medication effects, and functional restoration. Learn how compassionate, tailored interventions help aging patients maintain dignity, oral function, and overall health well into their later years.",
  },
  {
    image: painManagement,
    title: "Pain Management",
    subtitle: "Pain Management in Dentistry",
    description:
      "Pain control is crucial in dentistry. Learn about local anesthesia, sedation, non-opioid analgesics, and chronic pain syndromes like TMD. Understand post-operative care, behavioral approaches, and patient communication. Explore how comprehensive pain management strategies enhance treatment outcomes and patient satisfaction across surgical, restorative, and preventative dental procedures.",
  },
  {
    image: oralOncology,
    title: "Oral Oncology",
    subtitle: "Innovations in Oral Oncology Care",
    description:
      "Oral oncology addresses malignant lesions of the oral cavity. Learn about risk screening, surgical techniques, radiation protocols, and post-treatment rehabilitation. Understand how early detection and integrative care models enhance survival and quality of life. Explore emerging therapies reshaping how oral cancers are diagnosed, managed, and followed up.",
  },
  {
    image: pediatricDentistry,
    title: "Pediatric Dentistry",
    subtitle: "Caring for the Youngest Smiles",
    description:
      "Pediatric dentistry promotes the oral health of children from infancy through adolescence. Learn techniques for behavior management, prevention, fluoride use, and minimally invasive care. Understand growth-related issues, trauma management, and care for special needs populations. Discover how early interventions establish lifelong positive dental habits and oral health.",
  },
  {
    image: endodontics,
    title: "Endodontics",
    subtitle: "Inside the Tooth: The World of Endodontics",
    description:
      "Endodontics treats diseases of the dental pulp and periapical tissues. Learn about root canal therapy, diagnostic tools, pain control, and retreatment. Discover advances in imaging, instrumentation, and biocompatible materials that preserve natural teeth and alleviate pain, ensuring long-term function and stability for patients with complex pulpal issues.",
  },
  {
    image: laserDentistry,
    title: "Laser Dentistry",
    subtitle: "Precision with Light: Laser Dentistry Explained",
    description:
      "Laser dentistry offers minimally invasive treatments using focused light energy. Learn applications in soft tissue surgery, caries removal, and periodontal therapy. Explore benefits like less bleeding, reduced pain, and quicker healing. Understand how laser integration improves efficiency, patient experience, and outcomes across various dental disciplines and procedures.",
  },
  {
    image: cosmeticDentistry,
    title: "Cosmetic Dentistry",
    subtitle: "The Art of Cosmetic Dentistry",
    description:
      "Cosmetic dentistry merges science and aesthetics to enhance smiles. Discover techniques including whitening, bonding, veneers, and smile design. Understand material innovations, facial analysis, and patient satisfaction factors. Explore how cosmetic procedures transform not only appearance but also confidence and emotional well-being through customized, natural-looking dental restorations.",
  },
  {
    image: gerontology,
    title: "Digital Dental Education",
    subtitle: "Digital Tools in Dental Learning",
    description:
      "Digital education revolutionizes dental training with simulations, e-learning platforms, and immersive technologies. Learn how online modules, virtual reality, and AI-driven assessment improve skill development, clinical reasoning, and accessibility. Explore the challenges, benefits, and future direction of digital pedagogy in preparing tomorrow's dental professionals more effectively and inclusively.",
  },
  {
    image: dentalStemCells,
    title: "Dental Stem Cells",
    subtitle: "Unlocking Dental Stem Cell Power",
    description:
      "Dental stem cells offer regenerative promise in oral and systemic care. Explore how they're harvested from pulp, differentiate into multiple tissues, and support future therapies. Learn about applications in bone regeneration, nerve repair, and bioengineering. Discover how dental stem cells are reshaping the future of restorative dental science.",
  },
];

const StaticTracks = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <style>{`
        @keyframes pulseShadow {
          0%, 100% {
            box-shadow: 0 0 0px #e8af2e;
          }
          50% {
            box-shadow: 0 0 18px 6px #e8af2e;
          }
        }

        .animate-pulseShadow {
          animation: pulseShadow 3s ease-in-out infinite;
        }

        .transition-custom {
          transition: all 0.8s ease-in-out;
        }
      `}</style>

      <div className="relative mt-14">
        {/* Fixed Top-Right Button */}
        <div
          className="fixed top-[22%] right-[1%] z-50 transition-custom"
        >
          <a
            href="/abstract-submission"
            aria-label="Submit abstract"
            className="bg-one rounded-full text-white text-sm font-medium px-3 py-3 select-none transition-transform hover:scale-110 animate-pulseShadow"
          >
            Submit Abstract
          </a>
        </div>

        {/* Track Content */}
        <div className="container mx-auto px-4 py-10 space-y-20 flex flex-col items-center">
          {tracks.map((track, index) => (
            <div
              key={index}
              className="relative w-[80%] flex flex-col md:flex-row items-stretch md:space-x-6"
            >
              <div className="flex-shrink-0 bg-white border shadow-xl rounded-2xl p-2 w-full md:w-1/3">
                <img
                  src={track.image}
                  alt={track.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
              </div>
              <div className="bg-white border shadow-xl rounded-2xl p-6 w-full md:w-2/3 mt-12 md:mt-0 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-1 text-one flex items-center gap-2">
                  <Sparkle className="fill-one" />
                  {track.title}
                </h2>
                <h3 className="text-xl text-gray-600 font-semibold mb-3">
                  {track.subtitle}
                </h3>
                <p className="text-md text-gray-800 leading-relaxed">
                  {track.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default StaticTracks;